<template>
  <div>
    <v-container>
      <h2 class="mb-2">
        Google Cloud API
      </h2>

      <div>
        <div style="margin-bottom: 10px;">
          <div class="intent-item z-border-red" style="padding: 10px 15px 0px;">
            <form>
              <v-layout wrap class="mb-3">
                <v-flex xs12 sm6>
                  <div>
                    <v-btn color="primary" :loading="loading" outline @click="onClickUploadButton">
                      <i class="fas fa-file-import"></i>
                      &nbsp;
                      {{ dataJson ? $t('edit_json_file') : $t('upload_json_file') }}
                    </v-btn>
                    <div>
                      {{
                        dataJson && dataJson.client_id ? ` client id : ${dataJson.client_id}` : ''
                      }}
                    </div>
                    <div>
                      {{
                        dataJson && dataJson.client_email
                          ? ` client email : ${dataJson.client_email}`
                          : ''
                      }}
                    </div>
                    <div>
                      {{
                        dataJson && dataJson.project_id
                          ? ` project id : ${dataJson.project_id}`
                          : ''
                      }}
                    </div>

                    <input
                      type="file"
                      :id="'JsonUpload'"
                      v-validate="'required'"
                      name="beacon_id"
                      accept=".json"
                      @input="onFileChange($event)"
                      style="overflow: hidden; position: fixed; width: 1px; height: 1px; z-index: -1; opacity: 0"
                    />
                  </div>
                </v-flex>
              </v-layout>
            </form>
          </div>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      loading: false,
      dataJson: null
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  mounted() {
    const vm = this
    vm.getGoogleApiCalendar()
  },
  methods: {
    async getGoogleApiCalendar() {
      let vm = this
      vm.loading = true
      var response = await api.getGoogleApiCalendar({
        pageId: vm.selectedBot.pageid
      })
      if (response.success) {
        vm.loading = false
        vm.dataJson = response.result
      }
    },
    onClickUploadButton() {
      document.getElementById('JsonUpload').click()
    },
    onFileChange(e) {
      let vm = this

      let files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      vm.readFile(files[0])
    },
    readFile(file) {
      let vm = this
      let reader = new FileReader()
      reader.onload = e => {
        let json = JSON.parse(e.target.result)
        vm.uploadGoogleApiCalendar(json)
      }
      reader.readAsText(file)
    },
    async uploadGoogleApiCalendar(json) {
      let vm = this
      vm.loading = true
      var response = await api.editGoogleApiCalendar({
        pageId: vm.selectedBot.pageid,
        body: json
      })
      if (response.success) {
        vm.dataJson = response.result
        vm.$swal.fire({
          title: vm.$t('Successfully'),
          text: vm.$t(''),
          type: 'success'
        })
      } else {
        vm.$swal({
          title: vm.$t('Error'),
          type: 'error',
          text: '',
          confirmButtonText: vm.$t('Confirm')
        })
      }
      vm.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.v-select.v-select--chips .v-select__selections {
  min-height: 42px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/intent/calendar/Setting.vue